/**
 * Extract tracking parameters from URL query string.
 */
export function getTrackingParams() {
  if (typeof window === 'undefined') return {}

  const params = new URLSearchParams(window.location.search)

  const tracking = {}

  // Standard tracking params
  const trackedParams = [
    'user_id',
    'email',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'intercom_conversation_id',
  ]

  for (const param of trackedParams) {
    const value = params.get(param)
    if (value) {
      tracking[param] = value
    }
  }

  return Object.keys(tracking).length > 0 ? tracking : null
}

/**
 * Get API base URL from environment or default.
 */
export function getApiBaseUrl() {
  // Check for environment variable (set during build)
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }

  // Default to /api (proxied in development, absolute in production)
  return '/api'
}

/**
 * Store tracking params in session storage for persistence.
 */
export function persistTrackingParams() {
  const params = getTrackingParams()
  if (params) {
    try {
      sessionStorage.setItem('tracking_params', JSON.stringify(params))
    } catch (e) {
      // Session storage not available
    }
  }
}

/**
 * Get persisted tracking params from session storage.
 */
export function getPersistedTrackingParams() {
  try {
    const stored = sessionStorage.getItem('tracking_params')
    return stored ? JSON.parse(stored) : null
  } catch (e) {
    return null
  }
}
